/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Аудит.
 * Этот proto-файл используется для событий в Clickhouse.
 * Его нельзя изменять
 */

/**
 * Событие
 */
export type AuditEventRequestDto = {
  /**
   * Время возникновения сигнала.
   * В секундах от 01.01.1970 года в UTC.
   * Присутствует всегда
   */
  time?: string
  /**
   * Тип события
   */
  kind: string
  /**
   * Данные до события.
   * Представляет собой сериализованный json
   */
  previousData?: string
  /**
   * Данные после события.
   * Представляет собой сериализованный json
   */
  currentData: string
  /**
   * Наименование сервиса
   */
  serviceName?: string
  /**
   * Идентификатор пользователя
   */
  userId?: number
}
/**
 * Событие
 */
export type AuditEventResponseDto = {
  /**
   * Время возникновения сигнала.
   * В секундах от 01.01.1970 года в UTC.
   * Присутствует всегда
   */
  time: string
  /**
   * Тип события
   */
  kind: string
  /**
   * Данные до события.
   * Представляет собой сериализованный json
   */
  previousData: string
  /**
   * Данные после события.
   * Представляет собой сериализованный json
   */
  currentData: string
  /**
   * Наименование сервиса
   */
  serviceName: string
  /**
   * Идентификатор пользователя
   */
  userId: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Событие
   */
  "AuditEvent": {
    "kind": "class",
    "text": "Событие",
    "fields": {
      /**
       * Время возникновения сигнала.
       * В секундах от 01.01.1970 года в UTC.
       * Присутствует всегда
       */
      "time": {
        "type": "int64",
        "text": "Время возникновения сигнала.\nВ секундах от 01.01.1970 года в UTC.\nПрисутствует всегда",
      },
      /**
       * Тип события
       */
      "kind": {
        "type": "string",
        "text": "Тип события",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Данные до события.
       * Представляет собой сериализованный json
       */
      "previousData": {
        "type": "string",
        "text": "Данные до события.\nПредставляет собой сериализованный json",
      },
      /**
       * Данные после события.
       * Представляет собой сериализованный json
       */
      "currentData": {
        "type": "string",
        "text": "Данные после события.\nПредставляет собой сериализованный json",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Наименование сервиса
       */
      "serviceName": {
        "type": "string",
        "text": "Наименование сервиса",
      },
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
    },
  },
}